import { createAction, props } from "@ngrx/store";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";
import { CreateLocationPayload, LocationUpdatePayload, ICompanyFilter, ICompanyFilterRequest, ICountry, ICurrency, ICustomer, ILocation, IPayment_term, IState } from "../models/customers.models";

// fetch all customers
export const FetchAllCustomers = createAction(
  '[ Customers ] - FetchAllCustomers',
);
export const FetchAllCustomersSuccess = createAction(
  '[ Customers ] - FetchAllCustomers Success ',
  props<{ customers: APIResponse<ICustomer> }>()
);
export const FetchAllCustomersError = createAction(
  '[ Customers ] - FetchAllCustomers Error',
);

// fetch customers
export const FetchCustomers = createAction(
  '[ Customers ] - FetchCustomers',
  props<{
    page: IPageCount,
    filter?: ICompanyFilterRequest | undefined
    key?: string | undefined
    sort_by?: string;
    sort_mode?: string
    subsidiary_id?: number | undefined
    deleted?: 'false' | 'true' | 'all'
  }>()
);
export const FetchCustomersSuccess = createAction(
  '[ Customers ] - FetchCustomers Success ',
  props<{ customers: APIResponse<ICustomer> }>()
);
export const FetchCustomersError = createAction(
  '[ Customers ] - FetchCustomers Error',
);

// get customer by id
export const GetCustomerById = createAction(
  '[ Customers ] - GetCustomerById',
  props<{ id: number }>()
);
export const GetCustomerByIdSuccess = createAction(
  '[ Customers ] - GetCustomerById Success ',
  props<{ customer: ICustomer }>()
);
export const GetCustomerByIdError = createAction(
  '[ Customers ] - GetCustomerById Error',
);


// get company by id
export const GetCompanyById = createAction(
  '[ Company ] - GetCompanyById',
  props<{ id: number }>()
);
export const GetCompanyByIdSuccess = createAction(
  '[ Company ] - GetCompanyById Success ',
  props<{ company: ICustomer }>()
);
export const GetCompanyByIdError = createAction(
  '[ Company ] - GetCompanyById Error',
);


// add customers
export const AddCustomer = createAction(
  '[ Customers ] - AddCustomer',
  props<{ customer: Omit<ICustomer, 'id'> }>()
);
export const AddCustomerSuccess = createAction(
  '[ Customers ] - AddCustomer Success ',
  props<{ customer: ICustomer }>()
);
export const AddCustomerError = createAction(
  '[ Customers ] - AddCustomer Error',
);

//update customers
export const UpdateCustomer = createAction(
  '[ Customers ] - UpdateCustomer',
  props<{ id: number, customer: any }>()
);
export const UpdateCustomerSuccess = createAction(
  '[ Customers ] - UpdateCustomer Success ',
  props<{ customer: ICustomer }>()
);
export const UpdateCustomerError = createAction(
  '[ Customers ] - UpdateCustomer Error',
);

//approve customers
export const CustomerApprobation = createAction(
  '[ Customers ] - CustomerApprobation',
  props<{ id: number, status: string }>()
);
export const CustomerApprobationSuccess = createAction(
  '[ Customers ] - CustomerApprobation Success ',
  props<{ customer: ICustomer }>()
);
export const CustomerApprobationError = createAction(
  '[ Customers ] - CustomerApprobation Error',
);

//Delete customers
export const DeleteCustomer = createAction(
  '[ Customers ] - DeleteCustomer',
  props<{ id: number }>()
);
export const DeleteCustomerSuccess = createAction(
  '[ Customers ] - DeleteCustomer Success ',
);
export const DeleteCustomerError = createAction(
  '[ Customers ] - DeleteCustomer Error',
);

//Restore (reactivate) soft-deleted customer
export const RestoreCustomer = createAction(
  '[ Customers ] - RestoreCustomer',
  props<{ id: number }>()
);
export const RestoreCustomerSuccess = createAction(
  '[ Customers ] - RestoreCustomer Success ',
);
export const RestoreCustomerError = createAction(
  '[ Customers ] - RestoreCustomer Error',
);

// fetch all payment terms
export const FetchAllpaymentTerms = createAction(
  '[ paymentTerms ] - FetchAllpaymentTerms',
);
export const FetchAllpaymentTermsSuccess = createAction(
  '[ paymentTerms ] - FetchAllpaymentTerms Success ',
  props<{ paymentTerms: APIResponse<IPayment_term> }>()
);
export const FetchAllpaymentTermsError = createAction(
  '[ paymentTerms ] - FetchAllpaymentTerms Error',
);



// Locations

// fetch all locations
export const FetchAllLocations = createAction(
  '[ Locations ] - FetchAllLocations',
);
export const FetchAllLocationsSuccess = createAction(
  '[ Locations ] - FetchAllLocations Success ',
  props<{ locations: APIResponse<ILocation> }>()
);
export const FetchAllLocationsError = createAction(
  '[ Locations ] - FetchAllLocations Error',
);

// fetch locations
export const FetchLocations = createAction(
  '[ Locations ] - FetchLocations',
  props<{
    page: IPageCount,
    filter?: ICompanyFilterRequest | undefined
    key?: string | undefined
    sort_by?: string;
    sort_mode?: string
    skipGlobalLoader?: boolean
  }>()
);
export const FetchLocationsSuccess = createAction(
  '[ Locations ] - FetchLocations Success ',
  props<{ locations: APIResponse<ILocation> }>()
);
export const FetchLocationsError = createAction(
  '[ Locations ] - FetchLocations Error',
);

// add locations
export const AddLocation = createAction(
  '[ Locations ] - AddLocation',
  props<{ payload: CreateLocationPayload }>()
);
export const AddLocationSuccess = createAction(
  '[ Locations ] - AddLocation Success ',
  props<{ location: ILocation }>()
);
export const AddLocationError = createAction(
  '[ Locations ] - AddLocation Error',
);

//update locations
export const UpdateLocation = createAction(
  '[ Locations ] - UpdateLocation',
  props<{ id: number, payload: LocationUpdatePayload }>()
);
export const UpdateLocationSuccess = createAction(
  '[ Locations ] - UpdateLocation Success ',
  props<{ location: ILocation }>()
);
export const UpdateLocationError = createAction(
  '[ Locations ] - UpdateLocation Error',
);

// Delete location contact
export const DeleteLocationContact = createAction(
  '[ Locations ] - DeleteLocationContact',
  props<{ locationId: number; contactId: number }>()
);
export const DeleteLocationContactSuccess = createAction(
  '[ Locations ] - DeleteLocationContact Success',
  props<{ locationId: number; contactId: number }>()
);
export const DeleteLocationContactError = createAction(
  '[ Locations ] - DeleteLocationContact Error',
);

//Delete locations
export const DeleteLocation = createAction(
  '[ Locations ] - DeleteLocation',
  props<{ id: number }>()
);
export const DeleteLocationSuccess = createAction(
  '[ Locations ] - DeleteLocation Success ',
);
export const DeleteLocationError = createAction(
  '[ Locations ] - DeleteLocation Error',
);


// fetch all countries
export const FetchAllCountries = createAction(
  '[ Countries ] - FetchAllCountries',
);
export const FetchAllCountriesSuccess = createAction(
  '[ Countries ] - FetchAllCountries Success ',
  props<{ countries: APIResponse<ICountry> }>()
);
export const FetchAllCountriesError = createAction(
  '[ Countries ] - FetchAllCountries Error',
);

// fetch all state
export const FetchAllStates = createAction(
  '[ States ] - FetchAllStates',
);
export const FetchAllStatesSuccess = createAction(
  '[ States ] - FetchAllStates Success ',
  props<{ states: APIResponse<IState> }>()
);
export const FetchAllStatesError = createAction(
  '[ States ] - FetchAllStates Error',
);

// fetch all currency
export const FetchAllCurrencies = createAction(
  '[ Currencies ] - FetchAllCurrencies',
);
export const FetchAllCurrenciesSuccess = createAction(
  '[ Currencies ] - FetchAllCurrencies Success ',
  props<{ currencies: APIResponse<ICurrency> }>()
);
export const FetchAllCurrenciesError = createAction(
  '[ Currencies ] - FetchAllCurrencies Error',
);


//loader actions

export const SetCustomersLoader = createAction(
  '[ Customers ] - SetLoading',
  props<{ isLoading: boolean }>()
);

export const SetCompanyLoader = createAction(
  '[ Company ] - SetLoading',
  props<{ isLoading: boolean }>()
);


export const SetStatesLoader = createAction(
  '[ Customers ] - SetStateLoading',
  props<{ isLoading: boolean }>()
);
export const SetCountryLoader = createAction(
  '[ Customers ] - SetCountryLoading',
  props<{ isLoading: boolean }>()
);
export const SetCurrenciesLoader = createAction(
  '[ Customers ] - SeCurrencytLoading',
  props<{ isLoading: boolean }>()
);
export const SetPaymentTermsLoader = createAction(
  '[ Customers ] - SetPaymentTermLoading',
  props<{ isLoading: boolean }>()
);

export const SetSearchCompanyLoader = createAction(
  '[ Loader ] - SearchLoader',
  props<{ isLoading: boolean }>()
);

// Filters
export const SetCompanyFilter = createAction(
  '[ Filters ] - SetCompanyFilter',
  props<{ keyword: string, advanced: ICompanyFilter | null }>()
);

// search
export const SetCompanySearch = createAction(
  '[ Search ] - SetCompanySearch',
  props<{ keyword: string }>()
);

// export
export const exportCompanies = createAction(
  '[Company] Export Companies',
  props<{ filter: ICompanyFilterRequest | undefined; key?: string | undefined; }>()
);
export const exportCompaniesSuccess = createAction(
  '[Company] Export Companies Success',
  props<{ file: Blob }>()
);
export const exportCompaniesFailure = createAction(
  '[Company] Export Companies Failure',
  props<{ error: any }>()
);

// Resend invitation
export const ResendInvitation = createAction(
  '[ Customers ] - ResendInvitation',
  props<{ contactId: number }>()
);
export const ResendInvitationSuccess = createAction(
  '[ Customers ] - ResendInvitation Success',
  props<{ response: any }>()
);
export const ResendInvitationError = createAction(
  '[ Customers ] - ResendInvitation Error',
  props<{ error: any }>()
);

